import { useQuery } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { FloatingTaskButton } from "./FloatingTaskButton";
import { aufgabenKnopfZeigen } from "./planungAnzeige";

export function GlobalFloatingTaskButton() {
  const { pathname } = useLocation();
  const imKurs = aufgabenKnopfZeigen(pathname);
  // Das Konto kommt aus der Sitzung (useCurrentUser), nicht aus auth.getUser(): Der Knopf hängt in App.tsx, und
  // getUser() fragte für jedes angemeldete Konto alle fünf Minuten das Netz (spaeter.md Punkt 49).
  const { data: user } = useCurrentUser();
  const userId = user?.id ?? null;

  // Check if user is admin
  const { data: isAdmin, isLoading } = useQuery({
    queryKey: ["is-admin-for-fab", userId],
    queryFn: async () => {
      if (!userId) return false;
      const { data } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", userId)
        .in("role", ["admin", "super_admin"])
        .limit(1);
      return (data || []).length > 0;
    },
    enabled: !!userId && imKurs,
    staleTime: 5 * 60 * 1000,
  });

  if (!imKurs || !userId || isLoading || !isAdmin) return null;
  return <FloatingTaskButton />;
}
